import Assets from "../assets"
const slugs = [
    "advertising",
    "cinema",
    "experience-design"
]
const indexes = [0, 2, 4, 3, 1, 5]
export default class Menu {
    isOpen = false;
    letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ#!@#$%&";
    constructor({ el, layer }) {
        this.layer = layer
        this.adminbar = el.querySelector("#wpadminbar");
        this.trigger = el.querySelector(".wp-block-cinetic-creatives-blocks-site-menu");
        this.main = el.querySelector("main");
        this.header = el.querySelector("header");
        gsap.set(this.main, {
            clipPath: `rect(0% 100% 100% 0%)`
        })

        this.initialize();
    }
    initialize() {
        const paths = document.body.querySelectorAll(".wp-block-cinetic-creatives-blocks-site-menu path");
        gsap.set(paths[0], {transformOrigin: `50% 50%`})
        gsap.set(paths[1], {transformOrigin: `50% 50%`})

        const mySplitText = new SplitText(this.trigger.querySelector(".text-menu"), { type: "chars" });
        const closeSplitText = new SplitText(this.trigger.querySelector(".text-close"), { type: "chars" });
        this.chars = mySplitText.chars;
        this.closeChars = closeSplitText.chars;

        this.chars.forEach((char, i) => {
            char.dataset.char = char.textContent
        })
        this.closeChars.forEach((char, i) => {
            char.dataset.char = char.textContent
        })

        this.trigger.addEventListener("mouseenter", () => {
            this.menuAnimation(this.chars)
            this.menuAnimation(this.closeChars)
        });
                
        this.boundClick = this.handleClick.bind(this)
        this.trigger.addEventListener("click", this.boundClick);
        // Start fetching the menu's project loops as soon as the visitor
        // reaches for the menu button (they are too heavy to load up front).
        const warm = () => Assets.loadMenuMedia()
        this.trigger.addEventListener("mouseenter", warm, { once: true });
        this.trigger.addEventListener("touchstart", warm, { once: true, passive: true });
        this.trigger.addEventListener("focus", warm, { once: true });

        const items = document.body.querySelectorAll(`.cinetic-creative-core-menu .wp-block-navigation-link a`);
        items.forEach((item, itemIndex) => {
            item.addEventListener("mouseover", () => {
                if (this.isOpen) {
                    const fadeItems = [...items].filter((innerItem) => innerItem !== item);
                    gsap.to(fadeItems, { autoAlpha: 0.5 });
                    gsap.to(item, { autoAlpha: 1 })
                    
                    const href = item.getAttribute("href");
                    const matchedSlug = indexes[itemIndex];
                    // console.log("itemIndex", itemIndex)
                    // console.log("matchedSlug", matchedSlug, slugs, fadeItems)

                    // if (matchedSlug) {
                        this.layer.highlight(matchedSlug)
                    // } else {
                    //     this.layer.highlight(-1)
                    // }
                }
            })
            item.addEventListener("mouseleave", () => {
                // if (this.isOpen) {
                    this.layer.highlight(-1)
                    gsap.to(items, { autoAlpha: 1 })
                // }
            })
        })
        
        this.refresh();
    }
    menuAnimation(characters)  {
        characters.forEach((char, i) => {
            const originalText = char.dataset.char;

            gsap.to(char, {
                duration: 0.15,
                delay: 0.1 * i,
                ease: "none",
                onUpdate: () => {
                    char.innerText = this.letters.charAt(Math.floor(Math.random() * this.letters.length))
                },
                onComplete: () => {
                    char.innerText = originalText;
                }
            });
        });
    }
    refresh() {
    }
    open() {
        Assets.loadMenuMedia()
        this.isOpen = true;
        return this.enter();
    }
    enter() {
        document.body.style.setProperty("overflow", "hidden")
        const timeline = new gsap.timeline()
        const homeLogo = document.body.querySelector(".is-style-logo-home");
        timeline.to(homeLogo, {
            autoAlpha: 0,
        }, 'a')

        this.menuAnimation(this.chars)
        this.menuAnimation(this.closeChars)

        timeline
            .add(
        this.layer.play(), "a")
            .add(this.overlayEnter(), `a`);
        const paths = document.body.querySelectorAll(".wp-block-cinetic-creatives-blocks-site-menu path");

        timeline
            .to(paths[0], {
                rotation: 225 -12.5,
                duration: .5, ease: "power42.in",
                y: 4
            }, "a")
        timeline
            .to(paths[1], {
                rotation: 135 + 12.5,
                duration: 0.5, ease: "power2.in",
                y: -4
            }, "a")
        timeline
            .to(document.body.querySelector(".wp-block-cinetic-creatives-blocks-site-menu .text-menu"), {
                autoAlpha: 0,
                duration: 0.5, ease: "power2.in"
            }, "a")
        timeline
            .to(document.body.querySelector(".wp-block-cinetic-creatives-blocks-site-menu .text-close"), {
                autoAlpha: 1,
                duration: 0.5, ease: "power2.in"
            }, "a")
        return timeline;
    }
    overlayEnter() {
        const timeline = new gsap.timeline();
        const overlay = document.body.querySelector(".cinetic-creative-core-menu");
        gsap.set(overlay, { perspective: 800, transformStyle: "preserve-3d" });
    
        const items = overlay.querySelectorAll(`
            .wp-block-navigation-link
        `)
        timeline
            .set(overlay, { autoAlpha: 1, overwrite: "true" }, 'a')
            .fromTo(items, { alpha: 0, y: 150, z: 200 }, { alpha: 1, y: 0, z: 0, overwrite: true, duration: 0.628, stagger: 0.02, ease: "power4.out" }, `a+=1.25`);
        return timeline;
    }
    close() {
        this.isOpen = false;
        return this.leave();
    }
    leave() {
        document.body.style.removeProperty("overflow")
        const timeline = new gsap.timeline()
        const overlay = document.body.querySelector(".cinetic-creative-core-menu");

        this.menuAnimation(this.chars)
        this.menuAnimation(this.closeChars)

        timeline.add(this.layer.focus(), "a")

        timeline.add(this.overlayLeave(), 'a')
        const paths = document.body.querySelectorAll(".wp-block-cinetic-creatives-blocks-site-menu path");
        timeline
            .to(paths, {
                rotation: 0,
                duration: 0.5, ease: "power2.in",
                y: 0
            }, 'a')

        timeline
            .to(document.body.querySelector(".wp-block-cinetic-creatives-blocks-site-menu .text-close"), {
                autoAlpha: 0,
                duration: 0.5, ease: "power2.in"
            }, 'a')
        timeline
            .to(document.body.querySelector(".wp-block-cinetic-creatives-blocks-site-menu .text-menu"), {
                autoAlpha: 1,
                duration: 0.5, ease: "power2.in"
            }, 'a')
        timeline
            .to(overlay, { autoAlpha: 0, duration: 0.314, ease: "power4.in" },'b');
        const homeLogo = document.body.querySelector(".is-style-logo-home");
        timeline.to(homeLogo, {
            autoAlpha: 1,
        }, 'b')
        return timeline;
    }
    overlayLeave() {
        const timeline = new gsap.timeline();
        const overlay = document.body.querySelector(".cinetic-creative-core-menu");
        const items = overlay.querySelectorAll(`
            .wp-block-navigation-link
        `)
        timeline.to(items, { alpha: 0, y: -150, z: 0, overwrite: true, duration: 0.5, stagger: 0.025, ease: "power4.in" });
        return timeline;
    }
    handleClick(e) {
        this.isOpen = !this.isOpen;
        this.openTimeline?.kill()
        this.leaveTime?.kill()
        if (this.isOpen) {
            this.openTimeline = this.enter();
        } else {
            this.leaveTime = this.leave()
        }
    }
}
